import React from 'react';

import FormBase from '../../../FormBase';
import InFieldsGroup from '../../../InFieldsGroup';
import TextField from '../../../fields/TextField';
import LocationFormComponent from '../../../form-components/LocationFormComponent';

import { useInputData } from '../../../context-provider/InputFormContextProvider';
import { EntityContactFormData as FormData } from '../../../util/form-config-data/InputFormAccountSettingsDataConfigs';

const SUBTITLE = 'Diese Kontaktdaten sind für andere Nutzer auf der Plattform sichtbar, ' +
    'um mit deinem Betrieb Kontakt aufzunehmen.';

const InputFormEntityContact = () => {
    const data = useInputData()
    return (
        <FormBase
            str_title='Betriebskontakt'
            str_subtitle={SUBTITLE}
        >
            <InFieldsGroup b_hasBorder={false}>
                <LocationFormComponent
                    b_hasCountyDistrictOptions={true}
                    obj_fields={FormData.fields}
                />
                <TextField
                    {...FormData.fields.phone}
                    str_chars={data[FormData.fields.phone.str_id][0]}
                />
                <TextField
                    {...FormData.fields.email}
                    str_chars={data[FormData.fields.email.str_id][0]}
                />
                <TextField
                    {...FormData.fields.webpage}
                    str_chars={data[FormData.fields.webpage.str_id][0]}
                />
                <TextField
                    {...FormData.fields.linkedin}
                    str_chars={data[FormData.fields.linkedin.str_id][0]}
                />
                <TextField
                    {...FormData.fields.twitter}
                    str_chars={data[FormData.fields.twitter.str_id][0]}
                />
                <TextField
                    {...FormData.fields.facebook}
                    str_chars={data[FormData.fields.facebook.str_id][0]}
                />
                <TextField
                    {...FormData.fields.instagram}
                    str_chars={data[FormData.fields.instagram.str_id][0]}
                />
                <TextField
                    {...FormData.fields.tiktok}
                    str_chars={data[FormData.fields.tiktok.str_id][0]}
                />
            </InFieldsGroup>
        </FormBase>
    )
}

export default InputFormEntityContact
